<template>
  <!--
  Todo:
  - Tages Einstellung Speichern (state of calender) ?
  - Text für Overview
  - Handbuch Endpoint ändern
   -->
  <v-app>
    <navigation v-if="!$route.meta.hideNavigation" :mobile="$vuetify.breakpoint.mdAndDown" />
    <v-main>
      <router-view/>
    </v-main>
    <message-bar />
    <cookie-consent />
<!--    <sync-service v-if="!$route.meta.hideNavigation" />-->
    <footer-bar />
  </v-app>
</template>


<script>
import { mapState } from 'vuex';
import { RunStates } from '@/libs/signalR/vuexStore/store/state';
import CookieConsent from './components/CookieConsent';
import Navigation from './components/Navigation';
import MessageBar from './components/MessageBar';
import FooterBar from './components/FooterBar';

export default {
  name: 'App',
  data: () => ({
  }),
  components: {
    CookieConsent,
    Navigation,
    MessageBar,
    FooterBar,
    //SyncService,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      runState: (state) => state.signalR.runState
    })
  },
  watch: {
    runState() {
      if (this.$route.path.startsWith('/loader')) return;
      this.handleRunStateChange()
    }
  },
  methods: {
    handleRunStateChange() {
      if (this.runState === RunStates.RunEdit) {
        console.log('App redirect to blocker')
        this.$router.push({ name: 'blocker' })
      } else {
        this.$router.push({ name: 'overview' })
      }
    }
  }
};
</script>
